module.exports = __webpack_public_path__ + "img/loas.7e9b5691.png";